import { SIX_HOURS } from "@walletconnect/time";

export const PUBLISHER_DEFAULT_TTL = SIX_HOURS;

export const PUBLISHER_CONTEXT = "publisher";
